export default "__VITE_PUBLIC_ASSET__5a2f1a68__"